import { useCallback, useContext, useMemo, useState } from "react";
import Layout from "../../../component/layout";
import SubHeader from "../../../component/subHeader";
import { AppContext } from "../../../context/AppContext";
import HandleOperation from "./handleOperation";
import TaskPlanListing from "./taskListing";
import Pagination from "../../../sharedComponent/Pagination";
import CreateTaskPlanner from "./createTaskPlanner";
import EditPlanTask from "./EditPlanTask";
import { simpleGetCallWithErrorResponse } from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";
import { useEffect } from "react";
import DisplayTask from "./DisplayTask";




function TaskPlanerr() {

    const { permissions } = useContext(AppContext)

    const [isLoading, setIsLoading] = useState(false)

    const [projectList, setProjectList] = useState([])

    const [isAddTaskPlan, setIsAddTaskPlan] = useState(false)

    const [perPage, setPerPage] = useState(25)

    const [isEditTask, setIsEditTask] = useState(false)

    const [taskList, setTaskList] = useState([])

    const [task, setTask] = useState({})

    const [startIndex, setStartIndex] = useState(0)

    const [currentPage, setCurrentPage] = useState(0)

    const [displayTask, setDisplayTask] = useState(false)

    const [search, setSearch] = useState('')


    const [currentSelectedProject, setCurrentSelectedProject] = useState('')


    const handleCreate = () => {
        setIsAddTaskPlan(true)
    }

    useEffect(() => {

        setStartIndex(currentPage * perPage)

    }, [currentPage])

    const buttons = [
        {
            title: '+ Create',
            isPermitted: permissions['Create Task Planner'],
            handleClick: handleCreate
        },
    ]

    const getTaskList = useCallback(() => {

        setIsLoading(true)

        simpleGetCallWithErrorResponse(ApiConfig.GET_TASK_PLANER_LIST).then((res) => {

            setIsLoading(false)

            if (res?.json?.success) {
                setTaskList(res?.json?.data)

                let projectList = res?.json?.data?.map((task) => task?.project?.projectName)

                setProjectList([...new Set(projectList)])

            }

        })

    }, [])

    useEffect(() => {
        getTaskList()
    }, [])

    const getTask = useCallback((id) => {


        simpleGetCallWithErrorResponse(ApiConfig.GET_TASK_PLANER + id).then(((res) => {


            if (res?.json?.success) {
                setTask(res?.json?.data)

                setDisplayTask(true)
            }
        }))


    }, [])

    const filteredTask = useMemo(() => {
        return taskList.filter((i) => {

            const matchesSearch =
                search?.trim()?.length
                    ? i?.filename?.toLowerCase()?.includes(search.toLowerCase())
                    : true;

            const matchesProject =
                currentSelectedProject
                    ? i?.project?.projectName === currentSelectedProject
                    : true;

            return matchesSearch && matchesProject;


        })
    }, [search, taskList, currentSelectedProject])

    return (
        <Layout>
            <SubHeader title={"Task Planner"} actions={buttons} />
            <HandleOperation
                setSearch={setSearch}
                setCurrentPage={setCurrentPage}
                setPerPage={setPerPage}
                projectList={projectList}
                currentSelectedProject={currentSelectedProject}
                setCurrentSelectedProject={setCurrentSelectedProject}
            />
            <TaskPlanListing setIsEditTask={setIsEditTask} taskList={filteredTask} getTask={getTask}
                search={search}
                startIndex={startIndex}
                perPage={perPage}
                loading={isLoading}
                currentSelectedProject={currentSelectedProject}
            />
            <Pagination
                data={filteredTask}
                pageChangeHandler={(e) => {
                    console.log(e?.selected);

                    setCurrentPage(e?.selected)
                }}
                usersPerPage={perPage}
                currentPage={currentPage}
                searchValue={search}
                searchedDataPageCounts={1}
            />
            <CreateTaskPlanner isAddTaskPlan={isAddTaskPlan} setIsAddTaskPlanner={setIsAddTaskPlan}
                getTaskList={getTaskList}
            />
            <EditPlanTask setIsEditTask={setIsEditTask} isEditTask={isEditTask} />
            <DisplayTask displayTask={displayTask} taskDetails={task} setDisplayTask={setDisplayTask} />
        </Layout>
    )

}

export default TaskPlanerr